import React, {Component} from "react"
import PropTypes from 'prop-types'
import {connect} from "react-redux"
import {Button, Container as Grid, Fade} from 'react-bootstrap'
import {IndexLinkContainer, LinkContainer} from 'react-router-bootstrap'
import Nav from 'react-bootstrap/Nav'
import {Redirect} from 'react-router-dom'
import Header from "../components/Header"
import Footer from "../components/Footer"
import ConfirmModal from "../components/ConfirmModal"
import {hideModal} from "../actions/modal"
import {changePassword, forgottenPassword, sessionInfo, sessionLogin, sessionLogout} from "../actions/session"
import {loadGeneralEnums} from "../actions/enums"
import {resetAlerts} from "../actions"
import routes from "../routes"
import * as Acl from "../utils/acl"
import moment from "moment";
import "moment/locale/cs";

class App extends Component {

	alertsTimeout = null;
	sessionInfoInterval = null;

	componentDidMount() {
		this.props.loadGeneralEnums(["roles", "parties", "partyAccounts"]);
		this.props.sessionInfo();
		moment().locale("cs");
	}

	componentDidUpdate(prevProps) {
		if (Acl.changedLoggedIn(this.props, prevProps)) {
			// just logged out
			if (this.sessionInfoInterval) {
				clearInterval(this.sessionInfoInterval)
			}
		} else if (Acl.changedLoggedIn(prevProps, this.props)) {
			// just logged in
			this.sessionInfoInterval = setInterval(this.props.sessionInfo, 10 * 60000)
			// this.forceUpdate()
		}
	}

	handleDismissClick = e => {
		this.props.resetAlerts();
		if (this.alertsTimeout) {
			clearTimeout(this.alertsTimeout)
		}
		if (e) {
			e.preventDefault()
		}
	};

	renderAlerts() {
		const {alerts} = this.props;

		const items = [];
		if (alerts.messages.length) {
			for (let k in alerts.messages) {
				if (alerts.messages.hasOwnProperty(k)) {
					items.push(<div key={k}>{alerts.messages[k]}</div>)
				}
			}
			if (this.alertsTimeout) {
				clearTimeout(this.alertsTimeout)
			}
			if (alerts.type === "success") {
				this.alertsTimeout = setTimeout(this.props.resetAlerts, 5000)
			}
		}

		return (
			<Fade in={alerts.messages.length > 0}>
				<div className="alert-top">
					<div className={"alert-inner alert alert-" + alerts.type + (alerts.messages.length ? "" : " hidden")}>
						<button className="pull-right btn btn-xs" onClick={this.handleDismissClick}>x</button>
						{items}
					</div>
				</div>
			</Fade>
		)
	}

	renderNavigation() {
		const {session} = this.props;
		if (!Acl.isLoggedIn(session)) {
			return null
		}

		// const basicNav = <Nav variant="pills" className="flex-column">
		// 	{/*<IndexLinkContainerto="/">*/}
		// 	{/*<NavItem title="Domů">Domů</NavItem>*/}
		// 	{/*</IndexLinkContainer>*/}
		//
		// 	<LinkContainer to="/" exact={true}>
		// 		<Nav.Link>Faktury</Nav.Link>
		// 	</LinkContainer>
		// 	<LinkContainer to="/transactions" exact={true}>
		// 		<Nav.Link>{"Transakce"}</Nav.Link>
		// 	</LinkContainer>
		// 	<LinkContainer to="/parties" exact={true}>
		// 		<Nav.Link>{"Subjekty"}</Nav.Link>
		// 	</LinkContainer>
		// </Nav>;
		//
		// if (!Acl.isAllowed(session, Acl.right.ADMIN)) {
		// 	return basicNav
		// }
		//
		// const adminNav = <Nav variant="xpills">
		// 	<LinkContainer to="/users" exact={true}>
		// 		<Nav.Link>{"Uživatelé"}</Nav.Link>
		// 	</LinkContainer>
		// 	<LinkContainer to="/admin" exact={true}>
		// 		<Nav.Link>{"Nastavení"}</Nav.Link>
		// 	</LinkContainer>
		// </Nav>;
		//
		// return <div>
		// 	{basicNav}
		// 	<div className={"nav"}>
		// 		<li className="nav-header">{"Administrace"}</li>
		// 	</div>
		// 	{adminNav}
		// </div>;
		return <nav className="navbar navbar-expand-lg navbar-light bg-light">
			<IndexLinkContainer to="/">
				<Button variant="link" className="navbar-brand">Fakturito</Button>
			</IndexLinkContainer>
			{/*<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"*/}
			{/*	aria-label="Toggle navigation">*/}
			{/*	<span className="navbar-toggler-icon"></span>*/}
			{/*</button>*/}

			<div className="collapse navbar-collapse" id="navbarSupportedContent">
				<ul className="navbar-nav mr-auto">
					<li className="nav-item">
						<LinkContainer to="/" exact={true}>
							<Nav.Link>Přehled</Nav.Link>
						</LinkContainer>
					</li>
					<li className="nav-item">
						<LinkContainer to="/parties" exact={true}>
							<Nav.Link>{"Subjekty"}</Nav.Link>
						</LinkContainer>
					</li>
					<li className="nav-item">
						<LinkContainer to="/invoices" exact={true}>
							<Nav.Link>Faktury</Nav.Link>
						</LinkContainer>
					</li>
					<li className="nav-item">
						<LinkContainer to="/transactions" exact={true}>
							<Nav.Link>Transakce</Nav.Link>
						</LinkContainer>
					</li>
					{/*<li className="nav-item dropdown">*/}
					{/*	<a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">*/}
					{/*		Administrace*/}
					{/*	</a>*/}
					{/*	<div className="dropdown-menu" aria-labelledby="navbarDropdown">*/}
					{/*		<a className="dropdown-item" href="#">Action</a>*/}
					{/*		<a className="dropdown-item" href="#">Another action</a>*/}
					{/*		<div className="dropdown-divider"></div>*/}
					{/*		<a className="dropdown-item" href="#">Something else here</a>*/}
					{/*	</div>*/}
					{/*</li>*/}
				</ul>
				{/*<form className="form-inline my-2 my-lg-0">*/}
				{/*	<input className="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search"/>*/}
				{/*	<button className="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>*/}
				{/*</form>*/}
			</div>
		</nav>;
	}

	render() {
		const {modal, hideModal, session, match: {params}} = this.props;
		if (Acl.isLoggedIn(session)) {
			if (this.props.location.pathname === '/login') {
				return <Redirect to={{pathname: '/'}}/>
			}
		} else {
			if (this.props.location.pathname !== '/login') {
				if (!this.props.session.hasFetchedInfo) {
					return <div className="loading-text"><span className="fa fa-refresh spin"/> Nahrává se</div>
				}
				return <Redirect to={{pathname: '/login', state: {from: this.props.location}}}/>
			}
		}

		return (
			<Grid>
				<Header onLogin={this.props.sessionLogin} onLogout={this.props.sessionLogout}
					onChangePassword={this.props.changePassword} onForgottenPassword={this.props.forgottenPassword}
					session={session} token={params.token}>{this.renderNavigation()}</Header>
				{this.renderAlerts()}
				<main id={"content-container"}>
					{routes}
				</main>
				<Footer/>
				{modal.isShowing && <ConfirmModal onCancel={hideModal} {...modal} />}
			</Grid>
		)
	}
}

App.propTypes = {
	headerContent: PropTypes.node,
	loadGeneralEnums: PropTypes.func.isRequired,
	sessionInfo: PropTypes.func.isRequired,
	sessionLogin: PropTypes.func.isRequired,
	sessionLogout: PropTypes.func.isRequired,
	changePassword: PropTypes.func.isRequired,
	forgottenPassword: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	alerts: PropTypes.object.isRequired,
	resetAlerts: PropTypes.func.isRequired,
	modal: PropTypes.object.isRequired,
	hideModal: PropTypes.func.isRequired,
	// Injected by React Router
	children: PropTypes.node
};

const mapStateToProps = (state, ownProps) => ({
	alerts: state.alerts,
	modal: state.modal,
	session: state.session,
});

export default connect(mapStateToProps, {
	loadGeneralEnums,
	sessionInfo,
	sessionLogin,
	sessionLogout,
	changePassword,
	forgottenPassword,
	resetAlerts,
	hideModal
})(App)
